export default "__VITE_ASSET__DVjinGet__"